import { motion } from "framer-motion";

const items = [
  "Webdesign",
  "Frontend Development",
  "Motion Design",
  "Brand Systems",
  "SEO & Sichtbarkeit",
  "Hosting in Deutschland",
  "Performance Engineering",
  "Conversion-fokussiert",
];

/**
 * Subtle infinite marquee — runs slowly, fades at edges, signals capability range.
 */
export default function CapabilitiesMarquee() {
  const loop = [...items, ...items];
  return (
    <section
      aria-label="Capabilities"
      data-testid="capabilities-marquee"
      className="relative py-10 border-y border-white/[0.05] bg-[#070708] overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-[#050505] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-[#050505] to-transparent" />

      <motion.div
        className="flex gap-12 whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          duration: 40,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {loop.map((it, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="font-display text-2xl sm:text-3xl text-zinc-300 tracking-tight">
              {it}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500/50" />
          </div>
        ))}
      </motion.div>
    </section>
  );
}
